import { types } from 'mobx-state-tree';
import { NewsFeedBaseModel } from './base.model';
import { ApartmentItem } from 'views/authorized/pages/news/feed-form/types';

export const NewsFeedEventModel = types.compose(
  'NewsFeedEvent',
  NewsFeedBaseModel,
  types.model({
    type: types.literal('event'),
    eventType: types.optional(
      types.enumeration(['accident', 'repair'] as const),
      'accident'
    ),
    resource: types.optional(
      types.enumeration(['electricity', 'water', 'heat', 'lift'] as const),
      'electricity'
    ),
    periodStart: types.optional(types.string, ''),
    periodEnd: types.optional(types.string, ''),
    isActual: types.optional(types.boolean, false),
    addresses: types.optional(
      types.array(
        types.model({
          house: types.optional(types.string, ''),
          address: types.optional(types.string, ''),
          apartments: types.optional(
            types.array(types.frozen<ApartmentItem>()),
            []
          ),
        })
      ),
      []
    ),
  })
);
